export default {
  FETCH_ALL_REQUEST: 'PROJECT_IMPORTS_FETCH_ALL_REQUEST',
  FETCH_ALL_FAILURE: 'PROJECT_IMPORTS_FETCH_ALL_FAILURE',
  FETCH_ALL_SUCCESS: 'PROJECT_IMPORTS_FETCH_ALL_SUCCESS'
}
